import type { ReactNode } from "react";
import { cx } from "@/shared/lib/cx";
import { X } from "@/shared/ui/icons";

export function ModalShell({
  title,
  description,
  onClose,
  children,
  footer,
  className,
}: {
  title: ReactNode;
  description?: ReactNode;
  onClose?: () => void;
  children: ReactNode;
  footer?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cx("dw-modal-shell", className)} role="document">
      <header className="dw-modal-header">
        <div className="dw-modal-heading">
          <h2>{title}</h2>
          {description && <p>{description}</p>}
        </div>
        {onClose && (
          <button
            type="button"
            className="dw-modal-close btn btn-ghost btn-sm btn-square"
            aria-label="Close"
            onClick={onClose}
          >
            <X aria-hidden="true" />
          </button>
        )}
      </header>
      <div className="dw-modal-content">{children}</div>
      {footer && <footer className="dw-modal-footer">{footer}</footer>}
    </div>
  );
}
